import { useIntl } from '../i18n';
import {AppError} from './app-error';

export class ErrorFactory {
    public static fromError(exception: any): AppError {
        if (exception instanceof AppError) {
            return exception;
        }

        let  error: AppError;

        error = new AppError("General", "GeneralError", useIntl().i18n.t("shared.errors.errorTypes.appError.unexpectedErrorHappened"), exception.stack);
        error.details = exception.message;

        return error;
        
    }
}